import { BASELINE_FIXTURE } from '../../../rcm-baseline/mockData';
import { fmtDate } from '../../../rcm-baseline/utils';
import { useBaseline } from '../BaselineContext';
import { SectionHead, StatusTag } from '../shared/BaselinePrimitives';

const fx = BASELINE_FIXTURE;
const launchLabel = fmtDate(fx.snapshot.launchDate);

const DEST_LABEL: Record<string, string> = {
  'claims/drafts': 'Claims · Drafts',
  'claims/rejected': 'Claims · Rejected',
  'claims/appeals': 'Claims · Appeals',
  'ai-queue': 'AI Queue · status checks',
  worklist: 'Worklist',
};

export function Day1Section() {
  const { launched, state } = useBaseline();
  const results = state === 'month3' || state === 'month12';

  return (
    <section id="pb-day1" className="pb-section" aria-labelledby="pb-day1-h">
      <SectionHead
        num={4}
        title={results ? 'Day-1 results' : 'Day-1 plan'}
        sub={<span id="pb-day1-h">{launched ? 'Live' : `Opens ${launchLabel}`}</span>}
      />

      <p className="pb-table-caption">
        During the first week nothing goes out without approval. ELVA rechecks every record in the PMS before it acts.
      </p>

      {fx.day1.map((a) => (
        <div className="pb-day1-row" key={a.id}>
          <span className="pb-day1-count">{a.items.toLocaleString('en-US')}</span>
          <div className="pb-day1-main">
            <div className="pb-day1-label">{a.label}</div>
            <div className="pb-day1-sub">
              {a.sub ? `${a.sub} · ` : ''}Reviewed in {DEST_LABEL[a.destination] ?? a.destination}
            </div>
          </div>
          <div className="pb-day1-right">
            <StatusTag kind="needs">Needs approval</StatusTag>
            <button
              type="button"
              className="pb-btn pb-btn-secondary"
              disabled={!launched}
              title={launched ? undefined : `Opens on ${launchLabel}`}
            >
              Review
            </button>
          </div>
        </div>
      ))}
    </section>
  );
}
